import type LogRocket from 'logrocket';

type Network = NonNullable<NonNullable<Parameters<typeof LogRocket.init>[1]>['network']>;
type IRequest = Parameters<NonNullable<Network['requestSanitizer']>>[0];
type IResponse = Parameters<NonNullable<Network['responseSanitizer']>>[0];

const REDACTED = '[REDACTED]';

const AUTH_REQUEST_HEADERS = [
  'Authorization',
  'authorization',
  'x-coast-auth',
  'X-Coast-Auth',
  'x-coast-verify',
  'X-Coast-Verify',
];

const AUTH_RESPONSE_HEADERS = ['x-set-coast-auth', 'X-Set-Coast-Auth', 'x-set-coast-verify', 'X-Set-Coast-Verify'];

export function sanitizeRequest(request: IRequest): IRequest {
  AUTH_REQUEST_HEADERS.forEach((header) => {
    delete request.headers[header];
  });
  if (request.body !== undefined) {
    request.body = REDACTED;
  }

  return request;
}

export function sanitizeResponse(response: IResponse): IResponse {
  AUTH_RESPONSE_HEADERS.forEach((header) => {
    delete response.headers[header];
  });
  if (response.body !== undefined) {
    response.body = REDACTED;
  }

  return response;
}
